module.exports = __webpack_public_path__ + "static/media/Round2.4aec48e1.JPG";